var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindGustTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6849,18.3563c0.237,0.4271,0.6225,0.6737,1.0256,0.6737 c0.6567,0,1.2405-0.6602,1.2405-1.53s-0.5838-1.53-1.2405-1.53H4.6579c-0.5357,0-0.97-0.4343-0.97-0.97s0.4343-0.97,0.97-0.97 h11.0526c1.785,0,3.1805,1.5783,3.1805,3.47s-1.3956,3.47-3.1805,3.47c-1.1371,0-2.1554-0.6513-2.722-1.6725 c-0.2599-0.4685-0.0908-1.0589,0.3776-1.3188C13.8346,17.7188,14.425,17.8879,14.6849,18.3563z M17.5543,8.5964 c-0.2758,0.4592-0.8717,0.6079-1.331,0.3321c-0.4592-0.2758-0.6079-0.8717-0.3321-1.331C16.4694,6.6349,17.457,6.03,18.5526,6.03 c1.785,0,3.1805,1.5783,3.1805,3.47s-1.3956,3.47-3.1805,3.47H3.2368c-0.5357,0-0.97-0.4343-0.97-0.97s0.4343-0.97,0.97-0.97 h15.3158c0.6567,0,1.2405-0.6602,1.2405-1.53s-0.5838-1.53-1.2405-1.53C18.1651,7.97,17.7941,8.1973,17.5543,8.5964z M10.6805,6.5 c0,0.5357-0.4343,0.97-0.97,0.97s-0.97-0.4343-0.97-0.97c0-1.2887,0.6502-2.4657,1.6899-3.067 C10.8846,3.1704,11.394,3.03,11.921,3.03c1.785,0,3.1805,1.5783,3.1805,3.47S13.706,9.97,11.921,9.97H4.6579 c-0.5357,0-0.97-0.4343-0.97-0.97s0.4343-0.97,0.97-0.97h7.2632c0.6567,0,1.2405-0.6603,1.2405-1.53s-0.5838-1.53-1.2405-1.53 c-0.1814,0-0.3566,0.0483-0.5194,0.1424C10.9737,5.3599,10.6805,5.8907,10.6805,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindGustTomorrowio);
export default __webpack_public_path__ + "static/media/wind-gust-tomorrowio.1e3dd80987752a66fb3e4c9d366f6f78.svg";
export { ForwardRef as ReactComponent };